// Shared styles for all info pages with ISU red theme
import { COLORS, LAYOUT } from '../../constants';

export const infoPageStyles = {
  pageContainer: {
    minHeight: '100vh',
    background: `linear-gradient(135deg, ${COLORS.background} 0%, #fdf5f6 100%)`,
    paddingBottom: LAYOUT.spacing.xxxl
  },

  header: {
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #9d0d1d 100%)`,
    padding: `${LAYOUT.spacing.xxxl}px ${LAYOUT.spacing.lg}px`,
    marginBottom: LAYOUT.spacing.xxl,
    boxShadow: `0 4px 20px ${COLORS.primary}30`,
  },

  headerTitle: {
    fontSize: 48,
    fontWeight: 800,
    color: 'white',
    margin: 0,
    marginBottom: LAYOUT.spacing.sm,
    textAlign: 'center',
    letterSpacing: 1
  },

  headerSubtitle: {
    fontSize: 20,
    color: 'rgba(255, 255, 255, 0.9)',
    margin: 0,
    textAlign: 'center',
    fontWeight: 400
  },

  contentContainer: {
    maxWidth: 900,
    margin: '0 auto',
    padding: `0 ${LAYOUT.spacing.lg}px`
  },

  section: {
    background: COLORS.white,
    borderRadius: LAYOUT.borderRadius.lg,
    padding: LAYOUT.spacing.xxl,
    marginBottom: LAYOUT.spacing.xl,
    boxShadow: `0 2px 12px ${COLORS.primary}10`,
    border: `1px solid ${COLORS.lightGray}`
  },

  sectionTitle: {
    fontSize: 28,
    fontWeight: 700,
    color: COLORS.primary,
    marginBottom: LAYOUT.spacing.lg,
    marginTop: 0
  },

  subsectionTitle: {
    fontSize: 22,
    fontWeight: 600,
    color: '#9d0d1d',
    marginBottom: LAYOUT.spacing.md,
    marginTop: LAYOUT.spacing.lg
  },

  text: {
    fontSize: 16,
    lineHeight: 1.6,
    color: COLORS.text.secondary,
    marginBottom: LAYOUT.spacing.md
  },

  list: {
    fontSize: 16,
    lineHeight: 1.8,
    color: COLORS.text.secondary,
    paddingLeft: LAYOUT.spacing.lg,
    marginBottom: LAYOUT.spacing.md
  },

  listItem: {
    marginBottom: LAYOUT.spacing.sm
  },

  highlight: {
    background: `${COLORS.primary}15`,
    border: `2px solid ${COLORS.primary}`,
    borderRadius: LAYOUT.borderRadius.md,
    padding: LAYOUT.spacing.lg,
    marginBottom: LAYOUT.spacing.lg
  },

  highlightTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: COLORS.primary,
    marginBottom: LAYOUT.spacing.sm,
    marginTop: 0
  },

  button: {
    background: `linear-gradient(135deg, ${COLORS.primary}, #9d0d1d)`,
    color: 'white',
    border: 'none',
    borderRadius: LAYOUT.borderRadius.md,
    padding: `${LAYOUT.spacing.md}px ${LAYOUT.spacing.xl}px`,
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: `0 4px 12px ${COLORS.primary}30`,
    transform: 'translateY(0)'
  },

  link: {
    color: COLORS.primary,
    textDecoration: 'none',
    fontWeight: 600,
    borderBottom: `2px solid transparent`,
    transition: 'border-color 0.2s ease'
  },

  divider: {
    height: 2,
    background: `linear-gradient(90deg, transparent, ${COLORS.primary}30, transparent)`,
    border: 'none',
    margin: `${LAYOUT.spacing.xl}px 0`
  }
};
